import { activationValueText } from "./roofingV2QualificationView";

const NOT_CONFIGURED = "not configured";

function readField(source, key) {
  if (!source || typeof source !== "object" || Array.isArray(source)) {
    return NOT_CONFIGURED;
  }
  if (!Object.prototype.hasOwnProperty.call(source, key) || source[key] == null) {
    return NOT_CONFIGURED;
  }
  return source[key];
}

export function roofingV2CapabilityView(settings) {
  const profile = settings && settings.provider_capability_profile;
  const profileObject = profile && typeof profile === "object" && !Array.isArray(profile);
  const calendar = profileObject ? readField(profile, "calendar") : NOT_CONFIGURED;
  const model = profileObject ? readField(profile, "model") : NOT_CONFIGURED;
  const provider = profileObject ? readField(profile, "provider") : NOT_CONFIGURED;
  const mandatoryAiDisclosure = readField(settings, "mandatory_ai_disclosure");
  const repairBallpark = readField(settings, "repair_ballpark");
  return {
    calendar: calendar === "" ? '""' : calendar,
    model: model === "" ? '""' : model,
    provider: provider === "" ? '""' : provider,
    repairBallpark: repairBallpark === "" ? '""' : repairBallpark,
    attendee: activationValueText(readField(settings, "attendee")),
    onSiteQuoterRole: activationValueText(readField(settings, "on_site_quoter_role")),
    followUpBookingFlow: activationValueText(readField(settings, "follow_up_booking_flow")),
    mandatoryAiDisclosure: mandatoryAiDisclosure === "" ? '""' : mandatoryAiDisclosure,
  };
}
